import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminProductionFactors } from '@/api/(admin)/fiber-production-factors';
import {
  buildProductionFactorsQs,
  type ProductionFactorsQueryInput,
  toProductionFactorsParams,
} from '../-utils/listParams';

/** Everything under this prefix — what the write paths invalidate. */
export const adminProductionFactorsQueryKey = [
  'admin',
  'fiber-production-factors',
] as const;

/**
 * Shared by the route loader and the page, so the prefetch warms what the page
 * reads. Keyed on the converted params, so both tabs cache independently.
 */
export function adminProductionFactorsQueryOptions(
  input: ProductionFactorsQueryInput,
) {
  const params = toProductionFactorsParams(input);
  return queryOptions({
    queryKey: [...adminProductionFactorsQueryKey, 'list', params] as const,
    queryFn: () =>
      fetchAdminProductionFactors(buildProductionFactorsQs(params)),
  });
}

export function useAdminProductionFactors(input: ProductionFactorsQueryInput) {
  const query = useQuery(adminProductionFactorsQueryOptions(input));

  const rows = query.data?.data ?? [];

  return {
    ...query,
    rows,
    totalCount: query.data?.metadata?.pagination?.total ?? 0,
  };
}
